import React, { useEffect, useState } from "react";
import { postGasto as addGasto } from "../helpers/rutaGastos";
import { getCuentaGastos } from "../helpers/rutaCuentaGastos";
import "../css/addclienteform.css";
import { Modal, Alert } from "react-bootstrap";
import "animate.css";

const AddGastoForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [cuentas, setCuentas] = useState({
    data: [],
    loading: true,
  });

  const [formValues, setFormValues] = useState({
    codgas: "",
    gasto: "",
    cuenta: "",
    activo: true,
  });

  useEffect(() => {
    const cargarCuentas = async () => {
      try {
        setErrorMsg("");

        const resp = await getCuentaGastos();
        console.log("📦 CuentaGastos:", resp);

        const lista = Array.isArray(resp)
          ? resp
          : Array.isArray(resp?.cuentagastos)
          ? resp.cuentagastos
          : [];

        setCuentas({
          data: lista.filter((x) => x.activo !== false),
          loading: false,
        });
      } catch (error) {
        console.error(
          "❌ Error al cargar cuentas de gasto:",
          error?.response?.data || error
        );
        setCuentas({ data: [], loading: false });
        setErrorMsg("No se pudieron cargar las cuentas de gasto");
      }
    };

    cargarCuentas();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () => {
    setFormValues({
      codgas: "",
      gasto: "",
      cuenta: "",
      activo: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const payload = {
      gasto: String(formValues.gasto || "").trim(),
      cuenta: formValues.cuenta,
      activo: !!formValues.activo,
    };

    if (!payload.cuenta) {
      setErrorMsg("Debe seleccionar una cuenta");
      return;
    }

    if (!payload.gasto) {
      setErrorMsg("Debe ingresar un gasto");
      return;
    }

    try {
      console.log("🚀 Payload POST /gastos:", payload);

      const resp = await addGasto(payload);
      console.log("✅ Gasto creado:", resp);

      if (resp?.ok === false) {
        setErrorMsg("No se pudo guardar el gasto");
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        resetForm();
        // setShow(false);
      }, 1200);
    } catch (error) {
      console.error("❌ Error al crear gasto:", error?.response?.data || error);
      setErrorMsg(
        error?.response?.data?.message ||
          error?.response?.data?.err?.message ||
          "Error al crear el gasto"
      );
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-5">
              <label>Cuenta</label>
              <select
                className="form-control"
                name="cuenta"
                value={formValues.cuenta}
                onChange={handleChange}
                required
                disabled={cuentas.loading}
              >
                <option value="">
                  {cuentas.loading
                    ? "Cargando cuentas..."
                    : "Seleccione una cuenta"}
                </option>

                {cuentas.data.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.codcga} - {c.cuentagasto}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-3 col-sm-5">
              <label>Gasto</label>
              <input
                type="text"
                className="form-control"
                name="gasto"
                maxLength="50"
                required
                value={formValues.gasto}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-5 col-sm-2 d-flex align-items-center">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="activo"
                  name="activo"
                  checked={!!formValues.activo}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="activo">
                  Activo
                </label>
              </div>
            </div>
          </div>

          {errorMsg ? (
            <Alert variant="danger" className="mt-3">
              {errorMsg}
            </Alert>
          ) : null}

          <div>
            <button type="submit" className="btn btn-dark mt-4 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddGastoForm;